module.exports = __webpack_public_path__ + "static/media/thumbnail-felveteli-epuulet-reszleges-bontasa-dorog.eb6e7a8d.jpg";